import { Divider, Grid, Stack } from '@vapor/material'
import { BillF, DepositF, ReservationF } from '../types/reservation-detail.types'
import { /* CustomerPerson, CustomerCompany, MainGuest, Agency, */ Description, ReservationPolicy, ContactInfo, SelfCheckin, ReferenceTags, getContactInfo } from './header-components'
import { Note } from './notes/note'
import { PaymentInfo } from './payment-info/payment-info'
import { Totals } from '../totals/totals'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'

export type ReservationHeaderComponentsCommonProps = {
  reservation: ReservationF
  readOnly: boolean
}

type ReservationHeaderProps = ReservationHeaderComponentsCommonProps & {
  readOnly: boolean
  onMailClick: () => void
  onDelete: () => void
  reservationLink: string | null
  bills: BillF[]
  deposits: DepositF[]
}

export default function ReservationHeader({ reservation, readOnly, onMailClick, onDelete, reservationLink, bills, deposits }: ReservationHeaderProps) {
  const referenceTags = [
    ...(reservation.reference.customerPerson?.tags ?? []),
    ...(reservation.reference.customerCompany?.tags ?? []),
    ...(reservation.reference.agency?.tags ?? []),
    ...(reservation.reference.mainGuest?.tags ?? []),
  ].filter((tag, index, self) => self.findIndex((t) => t.id === tag.id) === index)

  const { xs, sm } = useBreakpoints()
  const contactInfo = getContactInfo(reservation)
  const isShowPaymentAndPolicyAsRow = !reservation.webCheckinEnabled && xs && !sm

  const productionIds = bills.flatMap((bill) => bill.productions?.map((production) => production.production.id) ?? [])
  const billIds = bills.map((bill) => bill.id)
  const documentIdsFromBills = bills.flatMap((bill) =>
    bill.document?.id && bill.document?.creditNote?.id
      ? [bill.document?.id, bill.document?.creditNote?.id]
      : bill.document?.creditNote?.id
      ? [bill.document?.creditNote?.id]
      : bill.document?.id
      ? [bill.document?.id]
      : [],
  )
  const documentIdsFromDeposit = deposits.map((deposit) => deposit.id)

  return (
    <>
      <Grid container columns={48} spacing={1}>
        <Grid item xs={48} id="r1.1">
          <Description
            readOnly={readOnly}
            reservation={reservation}
            onDelete={onDelete}
            productionIds={productionIds}
            billIds={billIds}
            documentIds={[...documentIdsFromBills, ...documentIdsFromDeposit]}
          />
        </Grid>
        {(contactInfo.email.length > 0 || contactInfo.phone.length > 0) && (
          <Grid item xs={48}>
            <ContactInfo readOnly={readOnly} contactInfo={contactInfo} onMailClick={onMailClick} />
          </Grid>
        )}
        <Grid item xs={48}>
          <Divider light orientation="horizontal" />
        </Grid>
        {reservation.webCheckinEnabled && (
          <Grid item xs={24} mt={1}>
            <SelfCheckin readOnly={readOnly} reservation={reservation} reservationLink={reservationLink} />
          </Grid>
        )}
        <Grid item xs={isShowPaymentAndPolicyAsRow ? 48 : 24} id="r1.4" mt={1}>
          <Stack spacing={1} direction={isShowPaymentAndPolicyAsRow ? 'row' : 'column'} alignItems={isShowPaymentAndPolicyAsRow ? 'center' : 'start'}>
            <ReservationPolicy readOnly={readOnly} reservation={reservation} />
            <PaymentInfo readOnly={readOnly} reservation={reservation} />
          </Stack>
        </Grid>
        <Grid item xs={48}>
          <Divider light orientation="horizontal" />
        </Grid>
        <Grid item xs={48} mt={1}>
          <Note readOnly={readOnly} reservation={reservation} allowCheckinNote allowCheckoutNote allowRestaurantNote allowHousekeepingNote allowPortalNote />
        </Grid>
        {referenceTags.length > 0 && (
          <>
            {/* <Grid item xs={48}>
              <Divider light orientation="horizontal" />
            </Grid> */}
            <Grid item xs={48} md={24} mt={1}>
              <ReferenceTags tags={referenceTags} />
            </Grid>
          </>
        )}
        <Grid item xs={48}>
          <Divider light orientation="horizontal" />
        </Grid>
        <Grid item xs={48} sm={48} md={24} mt={1}>
          <Totals deposits={deposits} bills={bills} />
        </Grid>
        <Grid item xs={48}>
          <Divider orientation="horizontal" />
        </Grid>
      </Grid>

      {/* <HeaderFormDrawer //
        reservation={reservation}
        open={formDrawerOpen}
        onClose={() => setFormDrawerOpen(false)}
        onCancel={onCancel}
      /> */}
    </>
  )
}
